import { render } from "./AddContactModal.vue?vue&type=template&id=06d8a888&scoped=true"
import script from "./AddContactModal.vue?vue&type=script&lang=js"
export * from "./AddContactModal.vue?vue&type=script&lang=js"

import "./AddContactModal.vue?vue&type=style&index=0&id=06d8a888&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d8a888"]])

export default __exports__